import type * as Types from 'app/types/graphql';

import {
  DeviceTypeCountSelectFragmentDoc,
  ClickTypeCountSelectFragmentDoc,
  ChannelStatsSelectFragmentDoc,
  HeatmapVisitorStatsSelectFragmentDoc,
} from '../fragments/deviceTypeCount.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type HeatmapAnalyticsQueryVariables = Types.Exact<{
  where: Types.HeatmapAnalyticsWhereInput;
}>;

export type HeatmapAnalyticsQueryResponse = {
  heatmapAnalytics: {
    deviceTypeDistribution: Array<
      Pick<
        Types.DeviceTypeCount,
        | 'deviceType'
        | 'totalClicks'
        | 'totalSessions'
        | 'totalVisitors'
        | 'totalRevenue'
        | 'totalPageViewed'
        | 'totalPageViewedHaveTimeOnPage'
        | 'totalTimeOnPage'
        | 'avgScrollDepth'
        | 'engagedSessions'
        | 'totalSessionsThatCompletedCheckout'
      > & {
        clickTypes: Array<Pick<Types.ClickTypeCount, 'type' | 'totalCount'>>;
        channels?: Types.Maybe<Array<Types.Maybe<Pick<Types.ChannelStats, 'type' | 'totalCount'>>>>;
        visitors?: Types.Maybe<
          Array<Types.Maybe<Pick<Types.HeatmapVisitorStats, 'type' | 'totalCount'>>>
        >;
      }
    >;
  };
};

export const HeatmapAnalyticsDocument = `
    query HeatmapAnalytics($where: HeatmapAnalyticsWhereInput!) {
  heatmapAnalytics(where: $where) {
    deviceTypeDistribution {
      ...DeviceTypeCountSelect
    }
  }
}
    ${DeviceTypeCountSelectFragmentDoc}
${ClickTypeCountSelectFragmentDoc}
${ChannelStatsSelectFragmentDoc}
${HeatmapVisitorStatsSelectFragmentDoc}`;

export const useHeatmapAnalyticsQuery = <TData = HeatmapAnalyticsQueryResponse, TError = unknown>(
  variables: HeatmapAnalyticsQueryVariables,
  options?: UseQueryOptions<HeatmapAnalyticsQueryResponse, TError, TData>,
) => {
  return useQuery<HeatmapAnalyticsQueryResponse, TError, TData>(
    ['HeatmapAnalytics', variables],
    appFetcher<HeatmapAnalyticsQueryResponse, HeatmapAnalyticsQueryVariables>(
      HeatmapAnalyticsDocument,
      variables,
    ),
    options,
  );
};

useHeatmapAnalyticsQuery.getKey = (variables: HeatmapAnalyticsQueryVariables) => [
  'HeatmapAnalytics',
  variables,
];
